import { Suspense } from "react";
import { Outlet, useParams } from "react-router";
import { RouteFallback } from "@/components/layout/RouteFallback";
import { CourseBookingProvider } from "@/lib/courseBookingContext";

// コース詳細配下のルート (/:caseToken/:shopId/:productId/**) に共通する外枠。
// 購入フロー・キャンセルフローの各ページを Outlet でレンダリングする。
// CourseBookingProvider でコース詳細画面 (予約内容の選択) と購入者情報入力画面
// (購入者情報の入力) 間の入力値を共有する (JPTP_CANSEI-1258)。
// ルートパラメータは Provider が sessionStorage へ退避する下書きのスコープになる
// (別商品の下書きを復元しないための照合キー。JPTP_CANSEI-1428)。
export function CourseDetailLayout() {
  const {
    caseToken = "",
    shopId = "",
    productId = "",
  } = useParams<{
    caseToken: string;
    shopId: string;
    productId: string;
  }>();

  return (
    <CourseBookingProvider caseToken={caseToken} shopId={shopId} productId={productId}>
      <Suspense fallback={<RouteFallback size={28} />}>
        <Outlet />
      </Suspense>
    </CourseBookingProvider>
  );
}
